import MobileDetect from 'mobile-detect';
import { prop } from 'lodash/fp';

export default (state) => !!new MobileDetect(prop('global.userAgent')(state)).mobile();
